import React from 'react';
import { FaBan } from 'react-icons/fa';
import { MdCheck } from 'react-icons/md';
import styled, { useTheme } from 'styled-components/macro';
import vb1 from '../../assets/images/virtualBackgrounds/vb1.webp';
import vb2 from '../../assets/images/virtualBackgrounds/vb2.webp';
import vb3 from '../../assets/images/virtualBackgrounds/vb3.webp';
import vb4 from '../../assets/images/virtualBackgrounds/vb4.webp';
import vb5 from '../../assets/images/virtualBackgrounds/vb5.webp';
import vb6 from '../../assets/images/virtualBackgrounds/vb6.webp';
import vb7 from '../../assets/images/virtualBackgrounds/vb7.webp';
import vb8 from '../../assets/images/virtualBackgrounds/vb8.webp';
import vb9 from '../../assets/images/virtualBackgrounds/vb9.webp';
import vb10 from '../../assets/images/virtualBackgrounds/vb10.webp';
import vb11 from '../../assets/images/virtualBackgrounds/vb11.webp';
import vb12 from '../../assets/images/virtualBackgrounds/vb12.webp';
import vb13 from '../../assets/images/virtualBackgrounds/vb13.webp';
import vb14 from '../../assets/images/virtualBackgrounds/vb14.webp';
import vb15 from '../../assets/images/virtualBackgrounds/vb15.webp';
import vb16 from '../../assets/images/virtualBackgrounds/vb16.webp';
import vb17 from '../../assets/images/virtualBackgrounds/vb17.webp';
import vb18 from '../../assets/images/virtualBackgrounds/vb18.webp';
import vb19 from '../../assets/images/virtualBackgrounds/vb19.webp';
import vb20 from '../../assets/images/virtualBackgrounds/vb20.webp';
import vb21 from '../../assets/images/virtualBackgrounds/vb21.webp';
import { Button } from 'react-covideo-common';

const Container = styled.div`
  display: flex;
  width: 100%;
  height: auto;
  background: #f6f7f9;
  border-radius: 5px;
  padding: 15px;
  flex-direction: column;
  box-sizing: border-box;
  .selected {
    border: 3px solid ${({ theme }) => theme.colors.primary[100]}; !important;
  }
`;

const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  box-sizing: border-box;
`;

const Title = styled.div`
  height: 24px;

  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 24px;
  color: #4e5461;
`;

const GridContainer = styled.div`
  display: flex;
  width: 100%;
  height: 278px;
  box-sizing: border-box;
  overflow-y: scroll;
  margin-top: 20px;
  flex-wrap: wrap;
`;

const Grid = styled.div`
  display: grid;
  width: 100%;
  grid-gap: 16.5px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  @media screen and (max-width: 768px) {
    grid-template-columns: 1fr 1fr;
  }
`;

type GridItemProps = {
  backgroundUrl?: string;
};
const GridItem = styled.div<GridItemProps>`
  background: url('${props =>
    props.backgroundUrl ? props.backgroundUrl : ''}');
  background-color: white;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  width: 100%;
  height: 100px;
  border-radius: 3px;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  border: 1px solid rgba(39, 42, 50, 0.1);
  box-sizing: border-box;
`;

export const virtualBackgrounds = [
  vb1,
  vb2,
  vb3,
  vb4,
  vb5,
  vb6,
  vb7,
  vb8,
  vb9,
  vb10,
  vb11,
  vb12,
  vb13,
  vb14,
  vb15,
  vb16,
  vb17,
  vb18,
  vb19,
  vb20,
  vb21,
];

interface Props {
  onSelect: any;
  onMainButtonClick: any;
  selectedVirtualBackgroundUrl?: any;
}
export const VirtualBackgrounds = ({
  onSelect,
  onMainButtonClick,
  selectedVirtualBackgroundUrl,
}: Props) => {
  const { colors } = useTheme();
  return (
    <>
      <Container>
        <Header>
          <Title>Select a virtual background</Title>
          <Button
            variant='primary'
            text={'Done'}
            icon={<MdCheck size={24} />}
            onClick={onMainButtonClick}
          />
        </Header>
        <GridContainer>
          <Grid>
            <GridItem
              onClick={() => {
                onSelect('', 'none', -1);
              }}
            >
              <div
                style={{
                  display: 'flex',
                  color: colors.primary[100],
                  justifyContent: 'center',
                  alignItems: 'center',
                  height: '100px',
                  fontSize: '34px',
                  borderRadius: '3px',
                  boxSizing: 'border-box',
                }}
                className={
                  selectedVirtualBackgroundUrl === '' ? 'selected' : ''
                }
              >
                <FaBan />
              </div>
            </GridItem>

            {virtualBackgrounds.map((image: string, index: number) => {
              return (
                <GridItem
                  key={image + index}
                  backgroundUrl={image}
                  className={
                    selectedVirtualBackgroundUrl === image ? 'selected' : ''
                  }
                  onClick={() => {
                    onSelect(image, 'default', index);
                  }}
                ></GridItem>
              );
            })}
          </Grid>
        </GridContainer>
      </Container>
    </>
  );
};
